import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  title?: string;
}
export function VideoModal({
  isOpen,
  onClose,
  videoId,
  title = 'Video'
}: VideoModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-487">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/80 z-50" onClick={onClose} data-id="element-488" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-489">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-4xl bg-white rounded-xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-490">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50" data-id="element-491">
                <h3 className="text-lg font-bold text-gray-900" data-id="element-492">{title}</h3>
                <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-200 transition-colors" aria-label="Close video" data-id="element-493">
                  <X className="w-5 h-5 text-gray-600" data-id="element-494" />
                </button>
              </div>

              {/* Video Container */}
              <div className="relative w-full" style={{
            paddingBottom: '56.25%'
          }} data-id="element-495">
                <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`} title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-496" />
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}